if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');
        this.elements = {
          shareButton: this.querySelector('button.share-button__button.hidden'), // 原生分享按钮
          shareSummary: this.querySelector('summary'),
          copyButton: this.querySelector('.share-button__copy'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('.share-button__message'),
          urlInput: this.querySelector('.field__input'),
        };

        this.urlToShare = this.elements.urlInput?.value || document.location.href;

        if (navigator.share) {
          // ✅ 支持 Web Share API 的情况（移动端原生分享）
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');

          this.elements.shareButton.addEventListener('click', () => {
            navigator
              .share({
                title: document.title,
                url: this.urlToShare,
                text: 'Check this out!',
              })
              .catch((err) => {
                console.warn('分享失败或用户取消：', err);
                // fallback 到复制面板
                this.elements.shareButton.classList.add('hidden'); 
                this.mainDetailsToggle.removeAttribute('hidden');
                this.mainDetailsToggle.setAttribute('open', '');
              });
          });
        } else {
          // ✅ fallback：不支持 Web Share API 的情况
          this.elements.shareSummary?.addEventListener('click', () => {
            this.elements.successMessage?.classList.add('hidden');
            this.elements.closeButton?.classList.add('hidden');
          });
        }

        // 📋 复制按钮事件
        this.elements.copyButton?.addEventListener('click', () => {
          const text = this.elements.urlInput?.value;
          if (!text) return;

          navigator.clipboard.writeText(text).then(() => {
            this.elements.successMessage.textContent =
              window.accessibilityStrings?.shareSuccess || 'Link copied!';
            this.elements.successMessage.classList.remove('hidden');
            this.elements.closeButton.classList.remove('hidden');
            this.elements.closeButton.focus();
          }).catch(() => {
            alert('复制失败，请手动复制链接');
          });
        });

        // ❌ 关闭 fallback 面板
        this.elements.closeButton?.addEventListener('click', () => {
          this.mainDetailsToggle.removeAttribute('open');
        });
      }
    }
  );
}
